import { useEffect } from 'react'

import { flushAnalytics } from 'utilities/analytics'

/**
 * Releases analytics buffered before PostHog existed.
 *
 * Rendered inside <PostHogProvider>, so by the time this effect runs PostHog
 * has been initialised and everything held back can actually be sent. Without
 * it those calls ran before init() and were silently dropped — which is why
 * `miniapp_launch` never appeared, `miniapp_platform` was empty on every event,
 * and a session restored at startup never got identified at all.
 *
 * Renders nothing.
 */
export default function TelemetryFlusher() {
    useEffect(() => {
        flushAnalytics()
    }, [])
    return null
}
